import React from 'react';

import WelcomeFeature from '@features/welcome';
import { useFormStore } from '@store/use-form-store';

import { useElearningWpOnSiteFlow } from './shared/ewos-flow-context';

function ElearningWpOnSiteWelcomePage() {
  const { goNext } = useElearningWpOnSiteFlow();
  const { changeRegistrationType, resetProcess } = useFormStore();

  const handleRegister = (type: string) => {
    resetProcess();
    changeRegistrationType(type);
    goNext();
  };

  return (
    <WelcomeFeature
      onSingleRegister={() => handleRegister('single')}
      onMultipleRegister={() => handleRegister('multiple')}
    />
  );
}

export default ElearningWpOnSiteWelcomePage;
